var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.052,
    height: 17.052,
    viewBox: "0 0 17.052 17.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.716 -0.716)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.526,
    cy: 8.526,
    r: 8.526,
    transform: "translate(0.716 0.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.424,168.625a.715.715,0,0,1-.51-.214l-2.642-2.685a.716.716,0,1,1,1.021-1l2.11,2.145,4.366-4.809a.716.716,0,1,1,1.059.963l-4.875,5.369a.716.716,0,0,1-.515.235Z",
    transform: "translate(-127.299 -155.983)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.bad6ccf614d8983b0cb38b363f755c1c.svg";
export { ForwardRef as ReactComponent };